import { MarkSpec, NodeSpec, Schema } from 'prosemirror-model';
import { ALL_MARKS, ALL_NODES } from './constants';
import { BaseMark } from './extensions/base/BaseMark';
import { BaseNode } from './extensions/base/BaseNode';
import { Extension } from './extensions/base/Extension';
import { isMark, isNode } from './utils';

/**
 * Builds a ProseMirror schema from node/mark extensions.
 * Call with no arguments to use the default full editor (all {@link ALL_NODES} and {@link ALL_MARKS}).
 */
export function createSchema(): Schema;
export function createSchema(extensions: Extension<void | NodeSpec | MarkSpec>[]): Schema;
export function createSchema(extensions?: Extension<void | NodeSpec | MarkSpec>[]): Schema {
  if (extensions === undefined) {
    return createSchemaFromExtensions([...ALL_NODES, ...ALL_MARKS]);
  }
  return createSchemaFromExtensions(extensions);
}

export function createSchemaFromExtensions(extensions: Extension<void | NodeSpec | MarkSpec>[]) {
  const nodes = extensions.filter(isNode).reduce(
    (acc, node: BaseNode) => {
      acc[node.name] = node.schema;
      return acc;
    },
    {} as Record<string, NodeSpec>
  );

  const marks = extensions.filter(isMark).reduce(
    (acc, mark: BaseMark) => {
      acc[mark.name] = mark.schema;
      return acc;
    },
    {} as Record<string, MarkSpec>
  );

  return new Schema({ nodes, marks });
}
